import React, {useState, useEffect} from 'react';
import CallToAction from '../../components/CallToAction/CallToAction';
// import CampaignFlow from '../../components/UI/CampaignFlow/CampaignFlow';
import HomePageAnimation from '../../assets/images/lekkervereinswettbewerb2026-animation-startseite-rgb.gif';
import HomePageAnimationStatic
    from '../../assets/images/lekkervereinswettbewerb2026-animation-startseite-rgb-static.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlay, faPause} from '@fortawesome/free-solid-svg-icons';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import {cleanLocationProp, sendVirtualPageView} from "../../shared/utility";
import {Row, Col, Button} from 'reactstrap';
import axios from '../../axios-base';
import {Helmet} from "react-helmet";
import {useLocation} from 'react-router-dom';

function Home(props) {
    const [ctas, setCtas] = useState(null);
    const [error, setError] = useState(false);
    const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);
    let location = useLocation();
    useEffect(() => {
        axios.get('/cta/', {
            params: {
                page: cleanLocationProp(location.pathname)
            }
        })
            .then(response => {
                setCtas(response.data);
            })
            .catch(error => {
                setError(true);
            });
        sendVirtualPageView("Willkommen");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let cta = (
        <React.Fragment>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
        </React.Fragment>
    );
    if (ctas) {
        cta = ctas.map((cta, key) => (
            <React.Fragment key={key}>
                {key === 2 ?
                    <Col sm="6"
                         className="my-3 d-flex align-items-center flex-column justify-content-center position-relative">
                        {/*<CampaignFlow />*/}
                        {isAnimationPlaying ? (
                            <img src={HomePageAnimation}
                                 alt="10 Jahre lekker Vereinswettbewerb; Fördersumme 35.000 Euro"
                                 className="align-self-center mw-100"/>
                        ) : (
                            <img src={HomePageAnimationStatic}
                                 alt="10 Jahre lekker Vereinswettbewerb; Fördersumme 35.000 Euro"
                                 className="align-self-center mw-100"/>
                        )}
                        <Button
                            size="sm"
                            color="secondary"
                            className="position-absolute bottom-0 end-0 m-2"
                            onClick={() => setIsAnimationPlaying(!isAnimationPlaying)}
                            aria-label={isAnimationPlaying ? 'Animation anhalten' : 'Animation abspielen'}
                            title={isAnimationPlaying ? 'Animation anhalten' : 'Animation abspielen'}
                            style={{height: '35.5px'}}
                        >
                            <FontAwesomeIcon icon={isAnimationPlaying ? faPause : faPlay} className="fa-fw"/>
                        </Button>
                    </Col>
                    : null}
                <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                    <CallToAction
                        btnClass={`anl_cta--${cta.page}--btn-${cta.position}`}
                        headline={cta.headline}
                        copy={cta.copy}
                        buttonText={cta.buttonText}
                        buttonColor={cta.buttonColor}
                        linkUrl={cta.linkUrl}
                        outline={cta.outline}
                        buttonVisibility={cta.buttonVisibility}
                    />
                </Col>
            </ React.Fragment>
        ));
    }

    return (
        <>
            <Helmet>
                <title>{`Willkommen | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>
            <Row>
                {cta}
            </Row>
        </>
    );
}

export default Home;
